/*
 * @Description: vr设备租赁合同
 * @Author: 杨志航
 * @Date: 2026-05-26 17:05:44
 */
import React from 'react'
import {
  Input,
  InputNumber,
  Form,
  Row,
  Col,
  Radio,
  Select,
  Icon,
  Checkbox,
} from 'antd'
import { changeMoneyToChinese } from '@/utils'

const FormItem = Form.Item
const { Option } = Select

const VrDevice = props => {
  const { oaidObj, accountObj, detail, form, setDeviceKeys, deviceKeys, contractData, setNextKey, nextKey, setTotalMonthlyFee, brandModelMap, totalMonthlyFee } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, getFieldsValue } = form

  // 添加设备行
  const addDeviceRow = () => {
    setDeviceKeys([...deviceKeys, nextKey])
    setNextKey(nextKey + 1)
  }

  // 删除设备行
  const removeDeviceRow = (key) => {
    const newKeys = deviceKeys.filter(k => k !== key)
    setDeviceKeys(newKeys)
    setFieldsValue({
      [`device_brand_${key}`]: undefined,
      [`device_model_${key}`]: undefined,
      [`unit_${key}`]: undefined,
      [`accessories_${key}`]: undefined,
      [`quantity_${key}`]: undefined,
      [`monthly_rental_fee_${key}`]: undefined
    })
    // 更新完成后计算
    setTimeout(() => {
      calculateTotalFee()
    }, 0)
  }

  // 选择品牌后，清空型号、单位、配件
  const onBrandChange = (key, device_brand) => {
    setFieldsValue({
      [`device_model_${key}`]: undefined,
      [`unit_${key}`]: '',
      [`accessories_${key}`]: []
    })
  }

  // 选择型号后，自动填单位并清空配件
  const onModelChange = (key, device_model) => {
    const device_brand = getFieldValue(`device_brand_${key}`)
    const unit = brandModelMap[device_brand]?.[device_model]?.unit || ''
    setFieldsValue({
      [`unit_${key}`]: unit,
      [`accessories_${key}`]: []
    })
  }

  // 计算月租金
  const calculateTotalFee = (field, key, newValue) => {
    const values = getFieldsValue()
    values[`${field}_${key}`] = newValue
    let total = 0
    deviceKeys.forEach(k => {
      const fee = parseFloat(values[`monthly_rental_fee_${k}`])
      const qty = parseFloat(values[`quantity_${k}`])
      if (!isNaN(fee) && !isNaN(qty)) {
        total += fee * qty
      }
    })
    setTotalMonthlyFee(total)
  }

  return (
    <>
      <div className="line"></div>
      <h3 className="apply-tit">租赁物品清单</h3>
      <div className="underline"></div>
      {
        deviceKeys.map(key => {
          const device_brand = getFieldValue(`device_brand_${key}`)
          const device_model = getFieldValue(`device_model_${key}`)
          const modelOptions = device_brand ? Object.keys(brandModelMap[device_brand] || {}) : []
          const accessoriesOptions = brandModelMap?.[device_brand]?.[device_model]?.accessories || []
          const unit = getFieldValue(`unit_${key}`)

          return (
            <Row gutter={22} key={key}>
              <Col span={3}>
                <Form.Item label="设备品牌">
                  {getFieldDecorator(`device_brand_${key}`, {
                    rules: [{ required: true, message: '请选择品牌' }]
                  })(
                    <Select placeholder="品牌" onChange={val => onBrandChange(key, val)}>
                      {Object.keys(brandModelMap).map(b => (
                        <Option key={b} value={b}>{b}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item label="设备型号及配置">
                  {getFieldDecorator(`device_model_${key}`, {
                    rules: [{ required: true, message: '请选择设备型号及配置' }]
                  })(
                    <Select placeholder="请选择" onChange={val => onModelChange(key, val)}>
                      {modelOptions.map(m => (
                        <Option key={m} value={m}>{m}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item label="单位">
                  {getFieldDecorator(`unit_${key}`, {
                    initialValue: unit,
                  })(
                    <Input readOnly style={{ width: '100%' }} />
                  )}
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item label="产品包含配件详情">
                  {getFieldDecorator(`accessories_${key}`)(
                    <Checkbox.Group options={accessoriesOptions} />
                  )}
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item label="设备数量">
                  {getFieldDecorator(`quantity_${key}`, {
                    rules: [
                      { required: true, message: '请输入设备数量' },
                      {
                        validator: (rule, value, callback) => {
                          if ((value && value <= 0) || (value && !Number.isInteger(value))) {
                            callback('请输入正整数')
                          } else callback()
                        }
                      }
                    ]
                  })(
                    <InputNumber 
                      min={0} 
                      style={{ width: '100%' }} 
                      onChange={val => calculateTotalFee('quantity', key, val)}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item label={`租赁费用（元/${getFieldValue(`unit_${key}`) || '套'}/月）`}>
                  {getFieldDecorator(`monthly_rental_fee_${key}`, {
                    rules: [
                      { required: true, message: '请输入费用' },
                      { pattern: /^\d+(\.\d{1,2})?$/, message: '最多保留2位小数' }
                    ]
                  })(
                    <InputNumber 
                      min={0} 
                      style={{ width: '100%' }} 
                      onChange={val => calculateTotalFee('monthly_rental_fee', key, val)}
                    />
                  )}
                </Form.Item>
              </Col>

              <Col span={2} style={{ display: 'flex', alignItems: 'left', marginTop: 40 }}>
                {key === deviceKeys[deviceKeys.length - 1] ?(
                  <Icon type="plus" style={{ fontSize: '35px' }} onClick={addDeviceRow} />
                ) : null}
                {
                  deviceKeys.length > 1 && <Icon
                    type="minus"
                    onClick={() => removeDeviceRow(key)}
                    style={{ marginLeft: 40, fontSize: '35px' }}
                  />
                }
              </Col>
            </Row>
          )
        })
      }
      <Row gutter={24}>
        <Col span={4}>
          <Form.Item label="硬件设备押金">
            {getFieldDecorator('deposit', {
              rules: [
                { required: true, message: '请输入押金' },
                { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入数字，保留2位小数' }
              ]
            })(
              <Input
                placeholder=""
                style={{
                  width: '80px',
                  border: 'none',
                  borderBottom: '1px solid #d9d9d9',
                  borderRadius: 0
                }}
              />
            )}
            <span>元</span>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="税率">
            {getFieldDecorator('tax_rate', {
              initialValue: '6%',
              rules: [
                { required: true, message: '请选择' }
              ]
            })(
              <Radio.Group>
                <Radio value="6%">6%</Radio>
                <Radio value="13%">13%</Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item style={{ marginBottom: 0 }} label={<><span style={{ color: '#f5222d' }}>*</span>其他设备周边配件</>} labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
              <span>原装手柄</span>
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('controller_quantity', {
                  rules: [
                    { required: true, message: '请输入' },
                    {
                      pattern: /^\d+$/,
                      message: '请输入数字'
                    }]
                })(
                  <Input
                    placeholder=""
                    style={{
                      width: '80px',
                      border: 'none',
                      borderBottom: '1px solid #d9d9d9',
                      borderRadius: 0,
                      padding: 0,
                      textAlign: 'center',
                    }}
                  />
                )}
              </Form.Item>
              <span>对，充电器</span>
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('charger_quantity', {
                  rules: [
                    { required: true, message: '请输入' },
                    {
                      pattern: /^\d+$/,
                      message: '请输入数字'
                    }
                  ]
                })(
                  <Input
                    placeholder=""
                    style={{
                      width: '80px',
                      border: 'none',
                      borderBottom: '1px solid #d9d9d9',
                      borderRadius: 0,
                      padding: 0,
                      textAlign: 'center',
                    }}
                  />
                )}
              </Form.Item>
              <span>个</span>
            </div>
            <div>
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('power_bank_type', {
                  initialValue: 1
                })(
                  <Radio.Group onChange={(e) => {
                    setFieldsValue({
                      power_bank_one_quantity: undefined,
                      power_bank_two_quantity: undefined,
                      power_bank_base_quantity: undefined,
                      power_bank_battery_quantity: undefined,
                    })
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {/* 单个充电宝选项 */}
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Radio value={1} />
                        <span>挂脖充电宝</span>
                        <Form.Item style={{ margin: 0 }}>
                          {getFieldDecorator('power_bank_one_quantity', {
                            rules: [{
                              required: getFieldValue('power_bank_type') === 1,
                              message: '请输入'
                            },
                            { pattern: /^\d+$/, message: '请输入数字' }
                            ]
                          })(
                            <Input
                              style={{
                                width: 40,
                                border: 'none',
                                borderBottom: '1px solid #d9d9d9',
                                borderRadius: 0,
                                textAlign: 'center',
                                padding: 0
                              }}
                            />
                          )}
                        </Form.Item>
                        <span>个</span>
                      </div>

                      {/* 充电宝套装选项 */}
                      <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}>
                        <Radio value={2} />
                        <span>磁吸充电宝</span>
                        <Form.Item style={{ margin: 0 }}>
                          {getFieldDecorator('power_bank_two_quantity', {
                            rules: [{
                              required: getFieldValue('power_bank_type') === 2,
                              message: '请输入'
                            },
                            { pattern: /^\d+$/, message: '请输入数字' }
                            ]
                          })(
                            <Input
                              style={{
                                width: 40,
                                border: 'none',
                                borderBottom: '1px solid #d9d9d9',
                                borderRadius: 0,
                                textAlign: 'center',
                                padding: 0
                              }}
                            />
                          )}
                        </Form.Item>
                        <span>套（</span>
                        <Form.Item style={{ margin: 0 }}>
                          {getFieldDecorator('power_bank_base_quantity', {
                            rules: [{
                              required: getFieldValue('power_bank_type') === 2,
                              message: '请输入'
                            },
                            { pattern: /^\d+$/, message: '请输入数字' }
                            ]
                          })(
                            <Input
                              style={{
                                width: 40,
                                border: 'none',
                                borderBottom: '1px solid #d9d9d9',
                                borderRadius: 0,
                                textAlign: 'center',
                                padding: 0
                              }}
                            />
                          )}
                        </Form.Item>
                        <span>个底座</span>
                        <Form.Item style={{ margin: 0 }}>
                          {getFieldDecorator('power_bank_battery_quantity', {
                            rules: [{
                              required: getFieldValue('power_bank_type') === 2,
                              message: '请输入'
                            },
                            { pattern: /^\d+$/, message: '请输入数字' }
                            ]
                          })(
                            <Input
                              style={{
                                width: 40,
                                border: 'none',
                                borderBottom: '1px solid #d9d9d9',
                                borderRadius: 0,
                                textAlign: 'center',
                                padding: 0
                              }}
                            />
                          )}
                        </Form.Item>
                        <span>块电池）</span>
                      </div>
                    </div>
                  </Radio.Group>
                )}
              </Form.Item>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
              <span>和</span>
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('other_context', {
                  rules: [
                    { required: false, message: '请输入' },
                  ]
                })(
                  <Input
                    placeholder=""
                    style={{
                      width: '180px',
                      border: 'none',
                      borderBottom: '1px solid #d9d9d9',
                      borderRadius: 0,
                      padding: 0,
                      textAlign: 'center',
                    }}
                  />
                )}
              </Form.Item>
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item label="租赁月租金" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
            <span>{totalMonthlyFee.toFixed(2)}元/月</span>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="大写" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <span>{changeMoneyToChinese(totalMonthlyFee.toFixed(2))}/月</span>
          </Form.Item>
        </Col>
      </Row>
      <div className="line"></div>
      <h3 className="apply-tit">交货方式与开票信息</h3>
      <div className="underline"></div>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="交货方式" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2, marginTop: 10 }}>
            {getFieldDecorator('delivery_method', {
              initialValue: '送货',
              rules: [{ required: true, message: '请选择交货方式' }]
            })(
              <Select placeholder="请选择交货方式" style={{ width: 240 }}>
                <Option value="送货">送货</Option>
                <Option value="自提">自提</Option>
              </Select>
            )}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label={<span style={{ fontWeight: 700 }}>甲方开票信息：</span>} colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2, marginTop: 10 }}>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="交货时间" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('delivery_days', {
              rules: [{
                required: true,
                message: '请填写交货时间'
              },
              { pattern: /^\d+$/, message: '请输入数字' }
              ]
            })(<Input placeholder="请填写数字" addonAfter="个工作日内" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="公司注册名称" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('invoice_company_name', {
              rules: [{ required: true, message: '请输入公司注册名称' }]
            })(<Input placeholder="请填写公司注册名称" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          {
            getFieldValue('delivery_method') === '送货' && <FormItem label="甲方或指定方名称" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
              {getFieldDecorator('company_name', {
                rules: [{ required: true, message: '请填写甲方或指定方名称' }]
              })(<Input placeholder="请填写甲方或指定方名称" style={{ width: 240 }} />)}
            </FormItem>
          }
        </Col>
        <Col span={12}>
          <FormItem label="纳税人识别号" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('tax_id', {
              rules: [{ required: true, message: '请填写纳税人识别号' }]
            })(<Input placeholder="请填写纳税人识别号" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          {
            getFieldValue('delivery_method') === '送货' && <FormItem label="指定签收人" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
              {getFieldDecorator('receiver_name', {
                rules: [{ required: true, message: '请填写指定签收人' }]
              })(<Input placeholder="请填写指定签收人" style={{ width: 240 }} />)}
            </FormItem>
          }
        </Col>
        <Col span={12}>
          <FormItem label="注册地址" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('company_address', {
              rules: [{ required: true, message: '请填写注册地址' }]
            })(<Input placeholder="请填写注册地址" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          {
            getFieldValue('delivery_method') === '送货' && <FormItem label="移动电话" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
              {getFieldDecorator('receiver_phone', {
                rules: [{ required: true, message: '请填写移动电话' }]
              })(<Input placeholder="请填写移动电话" style={{ width: 240 }} />)}
            </FormItem>
          }
        </Col>
        <Col span={12}>
          <FormItem label="注册电话" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('company_phone', {
              rules: [{ required: true, message: '请填写注册电话' }]
            })(<Input placeholder="请填写注册电话" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          {
            getFieldValue('delivery_method') === '送货' && <FormItem label="送货地址" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
              {getFieldDecorator('delivery_address', {
                rules: [{ required: true, message: '请填写送货地址' }]
              })(<Input placeholder="请填写送货地址" style={{ width: 240 }} />)}
            </FormItem>
          }
        </Col>
        <Col span={12}>
          <FormItem label="开户银行" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('bank_name', {
              rules: [{ required: true, message: '请填写开户银行' }]
            })(<Input placeholder="请填写开户银行" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
        </Col>
        <Col span={12}>
          <FormItem label="银行账号" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('account_number', {
              rules: [{ required: true, message: '请填写银行账号' }]
            })(<Input placeholder="请填写银行账号" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>
      <div className="line"></div>
      <h3 className="apply-tit">双方公司信息及联系方式</h3>
      <div className="underline"></div>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="甲方" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            <div>{oaidObj.name ? oaidObj.name : detail.partA}</div>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="乙方" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            <div>{accountObj.fullName ? accountObj.fullName : detail.partB}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('Aaddress', {
              rules: [{ required: true, message: '请输入甲方联系地址' }]
            })(<Input placeholder="请输入甲方联系地址" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            <div>{accountObj.address || accountObj.address == '' ? accountObj.address : JSON.stringify(contractData) != '{}' ? contractData.partB.address : ''}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="授权代表" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('Acontacts', {
              rules: [{ required: true, message: '请输入甲方授权代表姓名' }]
            })(<Input placeholder="请输入甲方授权代表姓名" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="授权代表" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('Bcontacts', {
              rules: [{ required: true, message: '请输入乙方授权代表姓名' }]
            })(<Input placeholder="请输入乙方授权代表姓名" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('Atel', {
              rules: [{ required: true, message: '请输入甲方联系电话' }]
            })(<Input placeholder="请输入甲方联系电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="联系电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            {getFieldDecorator('Btel', {
              rules: [{ required: true, message: '请输入乙方联系电话' }]
            })(<Input placeholder="请输入乙方联系电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
        </Col>
        <Col span={12}>
          <FormItem label="公司名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            <div>{accountObj.fullName ? accountObj.fullName : detail.partB}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
        </Col>
        <Col span={12}>
          <FormItem label="开户银行" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} style={{ marginBottom: 2 }}>
            <div>{accountObj.bankName || accountObj.bankName == '' ? accountObj.bankName : JSON.stringify(contractData) != '{}' ? contractData.partB.bank : ''}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
        </Col>
        <Col span={12}>
          <FormItem label="银行账号" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.bankNo || accountObj.bankNo == '' ? accountObj.bankNo : JSON.stringify(contractData) != '{}' ? contractData.partB.account : ''}</div>
          </FormItem>
        </Col>
      </Row>
    </>
  )
}

export default VrDevice